<template>
  <file-uploader
      v-model="photoFiles"
      :autoupload="false"
      :show-list="true"
      :show-drop="!isPhotoSet"
      :allow-delete="true"
      :auth="authToken"
      :baseURL="baseURL"
      :read-only="false"
      :list-mode="false"
      :clearDropzoneAfterSave="true"
      :dropzoneOptions="{maxFiles: 1, acceptedFiles: '.jpg,.jpeg,.png,.png'}"
      class="documents-uploader mb-3"
  >
    <template #title>
      <span class="text-red">
          <fa-icon icon="cloud-upload-alt" class="mr-1"/>
          {{ $t('profile.user_click_to_add_photo') }}
      </span>
    </template>
  </file-uploader>
</template>

<script>
import { FileUploader } from '@dealer-group/file-uploader'
import {mapState} from "vuex";

export default {
    name: "UserPhoto",
    components: {FileUploader},
    props: {
        user: {
            type: Object
        },
    },
    data() {
        return {
            processing: false,
            photoFiles: this.user.photoUuid ? [this.user.photoUuid] : [],
            userPhoto: this.user.photoUuid
        }
    },
    watch: {
      photoFiles: {
        deep: true,
        handler() {
          if (this.photoFiles.length > 0) {
            const [lastItem] = this.photoFiles.slice(-1);
            this.userPhoto = lastItem;
            this.saveUserPhoto();
          } else {
            this.userPhoto = null;
            this.deleteUserPhoto();
          }
        }
      },
    },
    computed: {
      ...mapState('Auth', {
        authToken: state => `Bearer ${state.token}`
      }),
      baseURL: () => process.env.VUE_APP_DX_URL,
      isPhotoSet() {
        return null !== (this.userPhoto || null)
      },
    },
    methods: {
      saveUserPhoto() {
          this.processing = true;
          this.$store
              .dispatch('User/updateUserPhoto', {uuid: this.user.uuid, photo: this.userPhoto})
              .finally(() => this.processing = false);
      },
      deleteUserPhoto() {
          this.processing = true;
          this.$store
              .dispatch('User/deleteUserPhoto', {uuid: this.user.uuid})
              .finally(() => this.processing = false);
      },
    }
}
</script>

<style scoped>

</style>